import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import i18n from '../../../../../shared/locales/no.json';

import AmbassadorEditable from './AmbassadorEditable';
import AmbassadorAdder from './AmbassadorAdder';

import * as actions from './../../actions/AmbassadorActions';

class AmbassadorContainer extends React.Component {
    static propTypes = {
        maxAmbassadors: PropTypes.number,
        ambassadors: PropTypes.object,
        profileId: PropTypes.number.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        maxAmbassadors: 9,
    };

    handleAdd = (image, model) => {
        const { dispatch, profileId } = this.props;
        return dispatch(actions.addAmbassador(profileId, image, model));
    };

    handleEdit = (ambassadorId, image, model) => {
        const { dispatch, profileId } = this.props;
        return dispatch(actions.editAmbassador(profileId, ambassadorId, model));
    };

    handleRemove = (ambassadorId) => {
        const { dispatch, profileId } = this.props;
        return dispatch(actions.deleteAmbassador(profileId, ambassadorId));
    };

    handleUpdateImage = (ambassadorId, image) => {
        const { dispatch, profileId } = this.props;
        return dispatch(actions.updateImage(profileId, ambassadorId, image));
    };

    renderAmbassadors() {
        if (!this.props.ambassadors) {
            return null;
        }

        return this.props.ambassadors.ambassadors.map((item, i) => (
            <div className="grid__unit" key={i}>
                <AmbassadorEditable
                    onRemove={this.handleRemove}
                    onSave={this.handleEdit}
                    onUpdateImage={this.handleUpdateImage}
                    {...item}
                />
            </div>
        ));
    }

    renderAmbassadorAdder() {
        if (!this.props.ambassadors) {
            return null;
        }

        return (
            this.props.ambassadors.ambassadors.length <
                this.props.maxAmbassadors && (
                <div className="grid__unit">
                    <AmbassadorAdder onSave={this.handleAdd} />
                </div>
            )
        );
    }

    render() {
        return (
            <section>
                <div className="panel">
                    <h2>{i18n.ambassadors.title}</h2>
                </div>
                <div className="grid t-grid grid--cols1to3">
                    {this.renderAmbassadors()}
                    {this.renderAmbassadorAdder()}
                </div>
            </section>
        );
    }
}

export default connect((state) => state)(AmbassadorContainer);
